// 日本語コメント: Why
// localStorage の "authTokens" は AuthProvider の useState 遅延初期化で未ガードのまま
// JSON.parse / jwt_decode されており、値が壊れていると初回 render で例外が発生し、
// ErrorBoundary 導入後もフォールバック止まりでアプリが復旧不能な白画面になる（Issue #61）。
// 読み取り・デコードを本モジュールに一元化し、破損を検出したら例外を外へ漏らさず、
// localStorage をクリアして確定的に「未ログイン」へ倒す（トップページ／PrivateRoutes 経由で
// /login に誘導され、再ログインで復旧できる）。

import jwt_decode from "jwt-decode";

export const readStoredAuthTokens = () => {
	const raw = localStorage.getItem("authTokens");
	if (!raw) return null;

	try {
		const parsed = JSON.parse(raw);
		if (typeof parsed?.access !== "string") {
			throw new Error("authTokens.access is missing or not a string");
		}
		// PR #97 Codexレビュー指摘: refresh欠落・非文字列も破損として扱う。
		// accessだけ有効な部分破損を通すと、期限切れ後のリフレッシュAPIへ
		// 不正なrefresh値を送り続けて復旧しにくいエラー状態になるため。
		if (typeof parsed?.refresh !== "string") {
			throw new Error("authTokens.refresh is missing or not a string");
		}
		// 復号可能性の検証。ここで失敗すれば catch に落ちて localStorage をクリアする。
		jwt_decode(parsed.access);
		return parsed;
	} catch (error) {
		console.error(
			"[authTokenStorage] Corrupted authTokens in localStorage; clearing.",
			error,
		);
		localStorage.removeItem("authTokens");
		return null;
	}
};

export const decodeUser = (authTokens) => {
	if (!authTokens?.access) return null;

	try {
		return jwt_decode(authTokens.access);
	} catch (error) {
		console.error("[authTokenStorage] Failed to decode access token.", error);
		return null;
	}
};
